import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function usePlanoOperacionalSubgrupoDropdownList(id?: string) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_GRUPO_PLANO_OPERACIONAL_SUBGRUPO_DROPDOWN_ID_EXTERNO, id],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_GRUPO_PLANO_OPERACIONAL_SUBGRUPO_DROPDOWN_ID_EXTERNO(id!), {});
      
      return data;
    },
    {
    //  keepPreviousData: true,
      enabled: !!id,
      refetchOnWindowFocus: false,
    }
  );
}

export default usePlanoOperacionalSubgrupoDropdownList;
